import React, { Component } from 'react';
import { AbstractIcon } from './AbstractIcon';
import { AbstractIconDefaultProps, AbstractIconPropTypes } from './utils';

export class CheckCircleIcon extends Component {
    static defaultProps = AbstractIconDefaultProps;
    static propTypes = AbstractIconPropTypes;

    render() {
        const props = this.props;

        return (
            <AbstractIcon viewBox="0 0 24 25" {...props}>
                <path
                    d="M14.803 11.5424L11.302 15.0434L9.19897 12.9424M12 21.9404C7.02943 21.9404 3 17.911 3 12.9404C3 7.96986 7.02943 3.94043 12 3.94043C16.9706 3.94043 21 7.96986 21 12.9404C21 17.911 16.9706 21.9404 12 21.9404Z"
                    stroke="#0A9142"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    fill="none"
                />
            </AbstractIcon>
        );
    }
}
